import { useCallback, useContext } from 'react'
import { ToastContext } from './ToastProvider'

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    throw new Error('useToast must be used inside a ToastProvider')
  }

  const success = useCallback(
    (message: string) => {
      ctx.push('success', message)
    },
    [ctx],
  )

  const error = useCallback(
    (message: string) => {
      ctx.push('error', message)
    },
    [ctx],
  )

  const info = useCallback(
    (message: string) => {
      ctx.push('info', message)
    },
    [ctx],
  )

  return { success, error, info }
}
